import { render, staticRenderFns } from "./SubscriptionDropdownMenu.vue?vue&type=template&id=0b54718e&"
import script from "./SubscriptionDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./SubscriptionDropdownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports